import axios from "axios";

class RequestProvider {
    constructor() {
        this.http = axios.create({
            baseURL: process.env.VUE_APP_URL_WEBPRESTADOR
        });
    }
    
    async get(url) {
        return this.http.get(url, {headers: {
            "Content-Type": "application/json"
        }});
    }

    async post(url, data) {
        return this.http.post(url, data);
    }

    async put(url, data) {
        return this.http.put(url, data);
    }

    async delete(url) {
        return this.http.delete(url);
    }
}

export default new RequestProvider();